import { useEffect, useRef } from 'react'
import {
  buildSearchItemData,
  FilterData,
  getItemSearchDataLayerParams,
  ItemSearchQueries,
  ItemSearchGtmData,
  getItemSearchFirstTimeDataLayerParams,
} from '@utilities/functions/buildSearchItemTagData'
import TagManager from 'react-gtm-module'

// Updates Item Search Google Tag Manager Event on query changes according to the algorithm:
// raise search event if search word or any filter changed
const useGtmItemSearchEvent = (
  query: ItemSearchQueries,
  filterData: FilterData
) => {
  const refData = useRef<ItemSearchGtmData | null>(null)
  useEffect(() => {
    const data = buildSearchItemData(query, filterData)
    const dataParams = refData.current
      ? getItemSearchDataLayerParams(data, refData.current)
      : getItemSearchFirstTimeDataLayerParams(data)
    refData.current = data
    if (!Object.values(dataParams).filter(Boolean).length) {
      return
    }
    TagManager.dataLayer({
      dataLayer: {
        event: 'handle-item-search',
        ...dataParams,
      },
    })
  }, [query])
}

export default useGtmItemSearchEvent
